import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsPlatformTopicItemPreview } from '@/learnpaths/components/LearnpathsAddElementsPlatformTopicItemPreview/LearnpathsAddElementsPlatformTopicItemPreview'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(platform-topic)/update/platform-topic/$elementId/preview/$topicId/$lectureId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsPlatformTopicItemPreview {...params} />
}
